import React, { CSSProperties, FC, useEffect } from 'react'
import { Tab, Tabs } from '@material-ui/core'

const MIN_ITEMS = 2

type DatasetTabsProps = {
  activeTab: string
  tabs: { label: string; value: string }[]
  style?: CSSProperties
  onChange: (tabName: number) => void
}

export const DatasetTabs: FC<DatasetTabsProps> = ({ tabs, activeTab, style = {}, onChange }) => {
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
    onChange(newValue || 0)
  }

  useEffect(() => {
    const nextValue = tabs.findIndex(({ label }) => label === activeTab) || 0
    setValue(nextValue)
  }, [tabs, activeTab])

  const tabsCount = tabs?.length || 0

  if (tabsCount < MIN_ITEMS) return null

  return (
    <Tabs
      scrollable={tabsCount > 5}
      value={value}
      onChange={handleChange}
      aria-label="Select dataset tabs"
      textColor="primary"
      indicatorColor="primary"
      style={{ backgroundColor: '#fff', borderBottom: '1px solid #ddd', ...style }}>
      {tabs.map((tab, i) => (
        <Tab key={i + tab.label} label={tab.label} />
      ))}
    </Tabs>
  )
}
